import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, OnInit, Output, ElementRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SimplebarAngularModule } from 'simplebar-angular';
import { LanguageService } from '../../../services/language.service';
import { LocalService } from '../../../services/local.service';
//import { AdminProfileService } from '../../admin-profile/admin-profile.service';
//import { baseURLForProfile } from '../../../environments/environment';
import { version } from '../../../../package.json';
@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [SimplebarAngularModule, CommonModule, FormsModule, TranslateModule, NgbModule],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss'
})
export class TopbarComponent implements OnInit {
  isSidebarOpen: boolean = false;
//#region  Declerations
  baseImageUrl='';
  @Output() mobileMenuButtonClicked = new EventEmitter();
  countryName: any;
  flagvalue: any;
  langValue: any;
  valueset: any;
  userData: any = {
    first_name: 'Anna',
    last_name: 'ji',
    role: 0
  };
  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.svg', lang: 'en' },
    { text: 'Deutsch', flag: 'assets/images/flags/germany.svg', lang: 'de' },
  ];
  applicationVersion: string = version;
  //#endregion Declerations

//#region CTOR
  constructor(private router: Router,
    public languageService:LanguageService,
    private localService:LocalService,
    //public adminProfileService:AdminProfileService,
    private elementRef: ElementRef 
  ) {
    // this.langValue= localStorage.getItem('locale');
    // if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.svg'; }



    // // Cookies wise Language set
    this.langValue = localStorage.getItem('locale');
    const val = this.listLang.filter(x => x.lang === this.langValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.svg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }


  }
  ngOnInit(): void {
    const data = this.localService.getJsonValue('loginUserData')??'[]';
    this.userData=JSON.parse(data);
    //this.adminProfileService.adminImage=this.baseImageUrl+this.userData.profile_image;
    //this.adminProfileService.firstName=this.userData.firstName;
    //this.adminProfileService.lastName=this.userData.lastName;

  }
  //#endregion CTOR
  


  toggleMobileMenu(event: any) {
    document.querySelector('.hamburger-icon')?.classList.toggle('open')
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }


  logout() {
    // localStorage.removeItem('loginUserData');
    localStorage.clear()
    this.router.navigate(['/login']);
    this.closeSidebar();
  }

  adminProfile(): void {
    this.router.navigate(['/user/changepassword']);
    this.closeSidebar();
  }

  openSidebar() {
    this.isSidebarOpen = true;
  }

  closeSidebar() {
    this.isSidebarOpen = false;
  }


  // Listener for document clicks to close sidebar when clicking outside
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (this.isSidebarOpen) {
      const clickedInside = this.elementRef.nativeElement.contains(event.target);
      if (!clickedInside) {
        this.closeSidebar();
      }
    }
  }

}
